/** Matches server-side rules in `SetupAccountRequest` / `UserCreate` (min 8). */
export const AUTH_PASSWORD_MIN_LENGTH = 8;

/** Inline copy for auth forms (shown after user starts typing, in red). */
export const AUTH_EMAIL_INVALID_MESSAGE = "Enter a valid email address.";

export const AUTH_PASSWORD_MIN_LENGTH_MESSAGE = `Password must be at least ${AUTH_PASSWORD_MIN_LENGTH} characters.`;

export const AUTH_FULL_NAME_INVALID_MESSAGE = "Enter your full name.";
export const AUTH_FIRST_NAME_INVALID_MESSAGE = "Enter your first name.";
export const AUTH_LAST_NAME_INVALID_MESSAGE = "Enter your last name.";
export const AUTH_PASSWORD_MISMATCH_MESSAGE = "Passwords do not match.";

/** Beta signup gate — shown wherever a not-yet-approved account lands. */
export const AUTH_PENDING_APPROVAL_MESSAGE =
  "Thanks for signing up! MagicBI is in beta, so our team reviews every new account. We'll email you as soon as yours is approved.";

/** Sign-in email check (`intent: "login"`) for an email with no account. */
export const AUTH_NO_ACCOUNT_MESSAGE = "We couldn't find an account for this email.";

/** Field error on the auth screens. */
export const AUTH_WORK_EMAIL_INVALID_MESSAGE =
  "Enter a valid work email, like name@company.com.";

/** Organization SSO stub — shown until the backend can discover SSO by domain. */
export const AUTH_SSO_NOT_FOUND_MESSAGE =
  "We could not find SSO for this email. Try another sign-in option.";

/** Client-side email check; API still validates with EmailStr. */
export function isValidEmail(email: string): boolean {
  const trimmed = email.trim();
  if (!trimmed) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
}

export function isValidAuthPassword(password: string): boolean {
  return password.length >= AUTH_PASSWORD_MIN_LENGTH;
}

/** `full_name` min_length=1 on the server. */
export function isValidFullName(fullName: string): boolean {
  return fullName.trim().length >= 1;
}

/**
 * Stricter check for the redesigned auth screens: the top-level domain needs at
 * least two characters (design spec §5). Gates the Continue button only; the
 * legacy screens keep `isValidEmail`.
 */
export function isValidWorkEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim());
}
